import React from 'react';
import './Footer.css';
import { FaFacebookF, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { MdLocationOn, MdPhone, MdEmail } from 'react-icons/md';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="info-columns">
                    <div className="info-item">
                        <MdLocationOn className="footer-icon" />
                        <div>
                            <h4>Dirección</h4>
                            <p>Cal. 8 Nro. 270, Urb. Carabayllo, distrito de Comas, Lima, Perú</p>
                        </div>
                    </div>

                    <div className="info-item">
                        <MdPhone className="footer-icon" />
                        <div>
                            <h4>Teléfono</h4>
                            <p>(01) 468-3460 / 940-434-785 / 963305642</p>
                        </div>
                    </div>

                    <div className="info-item">
                        <MdEmail className="footer-icon" />
                        <div>
                            <h4>Correo</h4>
                            <p>gerenciageneral@kalelsac.com</p>
                        </div>
                    </div>
                </div>

                <div className="social-row">
                    <h4>Síguenos</h4>
                    <div className="social-icons">
                        <a href="https://www.facebook.com/kalelsac" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <FaFacebookF />
                        </a>
                        <a href="https://www.youtube.com/kalelsac" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <FaYoutube />
                        </a>
                        <a href="https://www.linkedin.com/company/kalelsac" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <FaLinkedinIn />
                        </a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; 2024 Kalel SAC. Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}